/* Presentation only. Do not create a badge or change its value/update hooks. */
(() => {
  const enhance = root => {
    const update = () => {
      const value = root.querySelector('#ctz-pdp-coins-val');
      const badge = value?.closest('#ctz-purity-coins-badge');
      if (!badge) return;
      const buttons = root.querySelector('.product-detail__buy-buttons');
      if (buttons && buttons.nextElementSibling !== badge) buttons.after(badge);
      if (badge.dataset.ctzRefreshCopy) return;
      const heading = value.parentElement;
      const detail = heading.nextElementSibling;
      if (!detail) return;
      badge.dataset.ctzRefreshCopy = 'true';
      heading.replaceChildren(document.createTextNode('Earn '), value, document.createTextNode(' Chettyz Coins'));
      detail.textContent = 'Use coins for up to 10% off a future order.';
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(root, {childList: true, subtree: true});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
  };
  const initialize = scope => scope.querySelectorAll('[id^="MainProduct-"].ctz-pdp-refresh').forEach(root => {
    if (root.dataset.ctzRefreshInitialized) return;
    root.dataset.ctzRefreshInitialized = 'true';
    enhance(root);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
